


const units = [];

    units['meters'] = {
        id:'meters', label: 'm', short: 'm'
    };

    units['kilometers'] = {
        id:'kilometers', label: 'km', short: 'km'
    };

    units['miles'] = {
        id:'miles', label: 'mi', short: 'mi'
    };

    units['kilometersPerHour'] = {
        id:'kilometersPerHour', label: 'km/h', short: 'km/h'
    };

    units['milesPerHour'] = {
        id:'milesPerHour', label: 'mph', short: 'mph'
    };

    units['watts'] = {
        id:'watts', label: 'W', short: 'W'
    };

    units['minutes'] = {
        id:'minutes', label: 'min', short: 'min'
    };

    units['seconds'] = {
        id:'seconds', label: 's', short: 's'
    };

    units['kilogram'] = {
        id:'kilogram', label: 'kg', short: 'kg'
    };

    units['pound'] = {
        id:'pound', label: 'lb', short: 'lb'
    };

    units['beatsPerMinute'] = {
        id:'beatsPerMinute', label: 'bpm', short: 'bpm'
    };

    units['liter'] = {
        id:'liter', label: 'L', short: 'L'
    };

    units['litersPerMinute'] = {
        id:'litersPerMinute', label: 'L/min', short: 'L/min'
    };

    units['millilitersPerMinute'] = {
        id:'millilitersPerMinute', label: 'mL/min', short: 'mL/min'
    };

    units['millilitersPerKilogramPerMinute'] = {
        id:'millilitersPerKilogramPerMinute', label: 'mL/kg/min', short: 'mL/kg/min'
    };

    units['ratio'] = {
        id:'ratio', label: '', short: ''
    };

    units['percentage'] = {
        id:'percentage', label: '%', short: '%'
    };

    units['hectopascal'] = {
        id:'hectopascal', label: 'hPa', short: 'hPa'
    };

    units['oxygenConsumptionByWeight'] = {
        id:'oxygenConsumptionByWeight', label: 'C', short: 'C'
    };

    units['humidityPercentage'] = {
        id:'humidityPercentage', label: '%RH', short: '%RH'
    };

    units['partsPerMillion'] = {
        id:'partsPerMillion', label: 'ppm', short: 'ppm'
    };

    units['rrInterval'] = {
        id:'rrInterval', label: 'ms', short: 'ms'
    };

    units['revolutionsPerMinute'] = {
        id:'revolutionsPerMinute', label: 'rpm', short: 'rpm'
    };

    units['totalHemoglobinConcentration'] = {
        id:'totalHemoglobinConcentration', label: 'THb', short: 'THb'
    };

    units['degree'] = {
        id:'degree', label: '°', short: '°'
    };

    units['degreesCelsius'] = {
        id:'degreesCelsius', label: '°C', short: '°C'
    };

    units['diffHemoglobinConcentration'] = {
        id:'diffHemoglobinConcentration', label: 'HbDiff', short: 'HbDiff'
    };

    units['kilocaloriePerHour'] = {
        id:'kilocaloriePerHour', label: 'kcal/hr', short: 'kcal/hr'
    };




const measurementUnits = {

    find(unitId) {
        return units[unitId] ?? {
            label: unitId, short: unitId,
        };
    }

};

export default measurementUnits